export const isTinyMobileWidth = () => window.innerWidth < 550;
export const isMobileWidth = () => window.innerWidth < 850;
export const isHalfScreenWidth = () => window.innerWidth <= 1000;
export const isDesktopWidth = () => window.innerWidth > 1000;
export const isBigDesktopWidth = () => window.innerWidth > 1400;
